// removed by extract-text-webpack-plugin
module.exports = {"block":"BurgerButton__block-1XuRb","isBackMode":"BurgerButton__isBackMode-38-pJ","line":"BurgerButton__line-2gThU"};